import { Base } from "./base";
import { UntypedFormGroup } from "@angular/forms";
import { formatDateForBackend } from "../../helpers/date.helper";
import { Order } from "./order";

export interface RidersFilters {
  filter?: string;
  defaultTenantId?: number;
  onlyCurrentTenant?: boolean;
}

export interface RiderDTO {
  id?: number;
  name?: string;
  surname?: string;
  phone?: string;
  orders: Order[];
  active: boolean;
  default_tenant_id?: number;
  email?: string;
  password?: string;
}

export class Rider extends Base {

  name: string;
  surname: string;
  phone: string;
  defaultTenantId: number;
  active: boolean;
  email?: string;
  password?: string;


  constructor(source: RiderDTO) {
    super(source);
    if (source) {
      this.name = source.name;
      this.surname = source.surname;
      this.phone = source.phone;
      // this._dailyOrders = new Array<Order>();
      // if (source.orders) {
      //   source.orders.forEach(order => {
      //     this._dailyOrders.push(new Order(order));
      //   });
      // }
      // if (this._dailyOrders.length > 0) {
      //   this._dailyAmount = this._dailyOrders.map(o => o.amount).reduce((totalAmount, amount) => totalAmount + Number(amount), 0);
      // } else {
      //   this._dailyAmount = 0;
      // }
      //this.orders = new Array<Order>();
      this.active = source.active;
      this.defaultTenantId = source.default_tenant_id;
      this.email = source.email;
      this.password = source.password;
    }
  }

  toDTO(): RiderDTO {
    let result: RiderDTO = <RiderDTO>super.toDTO();
    result.name = this.name;
    result.surname = this.surname;
    result.phone = this.phone;
    //result.orders = this.dailyOrders;
    result.active = this.active;
    result.default_tenant_id = this.defaultTenantId;
    result.email = this.email;
    result.password = this.password;
    return result;
  }

  static fromFormGroup(formGroup: UntypedFormGroup, original?: Rider): Rider {
    const formModel = formGroup.value;
    let rider: Rider = new Rider(null);
    rider.name = formModel.name;
    rider.surname = formModel.surname;
    rider.phone = formModel.phone;
    rider.active = formModel.active;
    rider.defaultTenantId = formModel.defaultTenantId;
    rider.email = formModel.email;
    rider.password = formModel.password;

    if(original){
      rider.id = original.id;
    }
    
    return rider;
  }

}
